import React, { useEffect, useState } from 'react'
import { CloseButtonModal } from './CloseButtonModal'
import { getStateInfo } from '../../../../../helper/stateTranslate'
import logger from '../../../../../utils/logger'
import { UserProfileData } from './common-components/UserProfileData'
import { UserContactData } from './common-components/UserContactData'
import { dateFormat } from '../../../../../helper/dataFormat'


export const Subscribers = ({ toggleModal, isActive, userData, stateModel }) => {
  const [translationStatus, setTranslationStatus] = useState(null)

  useEffect(() => {

    if (userData.state) {

      const getState = getStateInfo(stateModel, userData.state)
      logger.info('status translationStatus: ', getState)

      setTranslationStatus(getState)
    }

  }, [userData])


  return (
    <div id="content-3" className={`dto-contacto content ${isActive ? 'active' : ''}`}>

      <CloseButtonModal toggleModal={toggleModal} />


      <div className="header-dto">
        <h4 className="header-nav-title">Suscripciones</h4>


        <UserProfileData
          userInfo={userData}
        />

        <UserContactData
          userInfo={userData}
        />

      
      </div>

      <hr className="under-header" />

      <div className="user-dto udto-2">



        <article className="code-status">

          {userData?.state &&
            <div className="user-status-title">
              <p className="status-title">Estado</p>
              <span className={`span-status span-${userData.state.toLowerCase()}`}>
                {translationStatus?.stateString}
              </span>
            </div>

          }


          {userData?.cardcode &&

            <div className="member-code">
              <p className="member-title">Codigo de Membresia</p>
              <p className="code-number">{userData?.cardcode}</p>
            </div>
          }




        </article>

{userData?.enrollments?.length > 0 && (
  <>
    <p className="header-nav-Subtitle">Historial de Suscripciones</p>

    <div className="dates">
      <p className="start-date">Fecha de Inicio</p>
      <p className="expiration-date">Fecha de Expiracion</p>
    </div>
<hr className="hr-dto-date" />
    {userData.enrollments.filter(e => e.typeId == 1).map((enrollment, index) => {
      if (!enrollment) return null;

      return (
          

          <div key={index} className="dates-1">
            <span className="start-number">
              {enrollment.approvedDate
                ? dateFormat(enrollment.approvedDate)
                : ""}
            </span>

            <span className="expiration-number">
              {enrollment.expirationDate
                ? dateFormat(enrollment.expirationDate)
                : ""}
            </span>
          </div>
        
      );
    })}
  </>
)}

        

        {/* <div className="dates-1">
          <span className="start-number">15/03/2024</span>
          <span className="expiration-number">15/03/2025</span>
        </div>

        <div className="dates-2">
          <span className="start-number">04/10/2022</span>
          <span className="expiration-number">04/10/2023</span>
        </div> */}

      </div>

    </div>
  )
}
